import * as React from 'react';
import { Box } from '@mui/material';
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@mui/material';
import Paper from '@mui/material/Paper';
import CircularProgress from '@mui/material/CircularProgress';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

export default function Templates({ Options, loading }) {
  function Row(props) {
    const { template } = props;
    return (
      <React.Fragment>
        <TableRow>
          <TableCell component="th" scope="row">
            {template?.['template.name']}
          </TableCell>
          <TableCell align="right">{template?.generatedCount || 0}</TableCell>
        </TableRow>
      </React.Fragment>
    );
  }
  return (
    <>
      {loading ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '75vh',
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <TableContainer
          component={Paper}
          sx={{ minWidth: '80vw', maxHeight: '62vh', overflow: 'auto' }}
        >
          <Table aria-label="collapsible table">
            <TableHead>
              <TableRow
                sx={{ position: 'sticky', top: 0, backgroundColor: '#fff' }}
              >
                <TableCell sx={{ fontWeight: 'bold' }}>Template Name</TableCell>
                <TableCell align="right" sx={{ fontWeight: 'bold' }}>
                Total Generated Templates
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Options?.map((template) => (
                <Row key={template.templateId} template={template} />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </>
  );
}
